__turbopack_context__.v({
  "className": "planar_14c7ad33-module__gVc2cG__className",
  "variable": "planar_14c7ad33-module__gVc2cG__variable",
});
